import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { StatusPropostaParceiro } from 'src/app/aplicacao/enum/status-proposta-parceiro.enum';
import { DatasHelper } from 'src/app/aplicacao/helper/datas.helper';
import { UtilsHelper } from 'src/app/aplicacao/helper/utils.helper';
import { Proposta } from 'src/app/aplicacao/models/proposta.model';

@Component({
  selector: 'app-detalhes-proposta',
  templateUrl: './detalhes-proposta.component.html',
  styleUrls: ['./detalhes-proposta.component.scss']
})
export class DetalhesPropostaComponent {
  utilsHelper = new UtilsHelper();
  datasHelper = new DatasHelper();
  @Input() proposta: Proposta;
  @Output() onClickAceitar: EventEmitter<any> = new EventEmitter();
  @Output() onClickNegociar: EventEmitter<any> = new EventEmitter();
  @Output() onClickDetalhesNegociacao: EventEmitter<any> = new EventEmitter();
  @Output() onClickCancelar: EventEmitter<any> = new EventEmitter();
  @Output() onClickSolicitarNovoCalculo: EventEmitter<any> = new EventEmitter();

  constructor(public route: Router,) {

  }
  clickBotaoAceitar() {
    this.onClickAceitar.emit(true);
  }

  clickBotaoNegociar() {
    this.onClickNegociar.emit(true);
  }

  clickBotaoDetalhesNegociacao() {
    this.onClickDetalhesNegociacao.emit(true);
  }

  clickBotaoSolicitarNovoCalculo(){
    this.onClickSolicitarNovoCalculo.emit(true);
  }

  clickBotaoCancelar() {
    this.onClickCancelar.emit(true);
  }

  podeVerMensagemVencimento() {
    return this.proposta?.diasParaOVencimento || this.proposta?.diasParaOVencimento == 0;
  }

  retornarTextoVencimento():string {
    if(this.proposta?.diasParaOVencimento == 0) {
      return "hoje";
    }
    else if(this.proposta?.diasParaOVencimento == 1) {
      return "em 1 dia ";
    }
    else {
      return `em ${this.proposta?.diasParaOVencimento} dias`;
    }
  }

  podeVerBotaoDownloadProposta() {
    return this.proposta?.urlDocumentoProposta !== null || this.proposta?.urlDocumentoProposta !== "";
  }

  podeVerBotaoAceitardProposta() {
    return this.proposta?.status === StatusPropostaParceiro.AguardandoAceite || 
           this.proposta?.status === StatusPropostaParceiro.AguardandoProposta && this.proposta?.valorCliente || 
           this.proposta?.status === StatusPropostaParceiro.EmAndamento && this.proposta?.negociacao?.statusNegociacao;
  }

  podeVerBotaoNegociarProposta() {
    return this.proposta?.status === StatusPropostaParceiro.AguardandoAceite ||
           this.proposta?.status === StatusPropostaParceiro.Aprovada ||
           this.proposta?.status === StatusPropostaParceiro.EmAndamento && this.proposta?.negociacao?.statusNegociacao;
  }

  podeVerBotaoNovoCalculo() {
    return this.proposta?.status === StatusPropostaParceiro.PropostaVencida
  }

  exibirBotaoCancelarProposta(): boolean {
    switch (this.proposta?.status) {
      case StatusPropostaParceiro.Reprovada:
        return false;
      case StatusPropostaParceiro.Pago:
        return false;
      case StatusPropostaParceiro.EmAndamento:
        return false;
      case StatusPropostaParceiro.ContatoComCliente:
        return false;
      default:
        return true;
    }
  }

  podeVerMensagemFeedback() {
    return this.proposta?.status === StatusPropostaParceiro.Reprovada ||
           this.proposta?.status === StatusPropostaParceiro.PropostaVencida
  }

  retornarMensagemDeFeedback() {
    switch(this.proposta?.status) {
      case StatusPropostaParceiro.Reprovada:
        return this.proposta?.motivoReprovacao;
      case StatusPropostaParceiro.PropostaVencida:
        return `Essa proposta teve o prazo de vencimento atingido em ${this.proposta?.dataVencimento ? this.datasHelper.formatarData(this.proposta?.dataVencimento) : '-'}. Você pode cancelar ou solicitar um novo cálculo.`;
    }
  }

  podeVerBotaoEnviarDocumento(): boolean {
    switch (this.proposta?.status) {
      case StatusPropostaParceiro.Pago:
        return false;
      case StatusPropostaParceiro.Reprovada:
        return false;
      case StatusPropostaParceiro.EmAndamento:
        return false;
      case StatusPropostaParceiro.PropostaVencida:
        return false;
      case StatusPropostaParceiro.ContatoComCliente:
        return false;
      default:
      return true;
    }
  }

  irParaEnviarDocumentos(propostaId, nomeCliente, documento, descricao = null, status = null): void {
    const des = descricao ? descricao : '';
    if(status === StatusPropostaParceiro.AguardandoCnd || status === StatusPropostaParceiro.DocumentoPendente) {
      this.route.navigate(['envio-cnds/detalhes-envio-cnds'], {
        queryParams: {
          propostaId: propostaId,
          nomeCliente: nomeCliente,
          documento: documento,
          descricao: descricao,
        }
      });
    } else {
      this.route.navigateByUrl(`proposta/enviar-documentos/${propostaId}`);
    }

  }
}
